// extracted by mini-css-extract-plugin
export default {"InclusionCriteriaSlide":"InclusionCriteriaSlide_InclusionCriteriaSlide__QIYoi","numbered":"InclusionCriteriaSlide_numbered__0scCw"};